import React, { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

// Animates the number inside a string like "~55%" or "500+" when it scrolls into view.
const CountUp = ({ value, duration = 1.6 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [, prefix = "", num = "", suffix = ""] = String(value).match(/^(\D*)([\d.]+)(.*)$/) || [];
  const [display, setDisplay] = useState(num ? "0" : value);

  useEffect(() => {
    if (!inView || !num) return;
    const target = parseFloat(num);
    const controls = animate(0, target, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => setDisplay(Math.round(v).toString()),
    });
    return () => controls.stop();
  }, [inView, num, duration]);

  return (
    <span ref={ref}>
      {num ? `${prefix}${display}${suffix}` : value}
    </span>
  );
};

export default CountUp;
